import { App } from '../../App.js'
import CONST_SOCKET from '../../const/socket'

import {
  createNewPostbackNode
} from '../../utils/functions'

// eslint-disable-next-line
export default async (component, event, ui) => {
  App.editor.view.area.pointermove(event)
  const { x, y } = App.editor.view.area.mouse

  const rcnSingleNode = await component.createNode()
  rcnSingleNode.position = [x, y]

  App.editor.addNode(rcnSingleNode)
  
  const newPostbackNode = await createNewPostbackNode()
  newPostbackNode.position = [x + 250, y]

  App.editor.addNode(newPostbackNode)

  App.editor.connect(
    rcnSingleNode.outputs.get(CONST_SOCKET.RCN_SINGLE_OUTPUT),
    newPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
  )
}